import { render } from "./addMedicine.vue?vue&type=template&id=1512bbad&scoped=true"
import script from "./addMedicine.vue?vue&type=script&lang=js"
export * from "./addMedicine.vue?vue&type=script&lang=js"

import "./addMedicine.vue?vue&type=style&index=0&id=1512bbad&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1512bbad"]])

export default __exports__